import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {StatusButton} from 'components/DSYS/StatusButton';

/**
 * /workstreams detail: the next update's panel — when it's due, and
 * the workstream's status button (the header's, same modal) to write it, so
 * posting an update reads as setting the status.
 */
export const NextUpdatePrompt = ({
  title,
  overdue,
  status,
  onLeaveUpdate,
}: {
  title: string;
  overdue: boolean;
  status: string;
  onLeaveUpdate: () => void;
}) => (
  <Box display="flex" flexDirection="column" alignItems="flex-start" style={{gap: 12}}>
    <Box display="flex" flexDirection="column" style={{gap: 4}}>
      <Text isBold color={overdue ? 'error' : 'standard'}>
        {title}
      </Text>
      <Text size="small" color="subtle">
        Set the status and say what changed.
      </Text>
    </Box>
    <StatusButton status={status} size="small" includeArchived onClick={onLeaveUpdate} />
  </Box>
);
